import * as React from 'react';
import './br.module.scss';

export const MobBr = () => <br styleName="mob-br" />;
export const SpBr = () => <br styleName="sp-br" />;
